export const SERVER_URL="https://back.yourfrenchteachers.com/api/v1"